<div
  class="position-relative"
  (mouseleave)="closeMenuAutomatically()"
  (mouseenter)="cancelCloseMenuAutomatically()"
  [tooltip]="(isOpen$ | async) === false ? dropdownTooltip : ''"
  placement="bottom"
>
  <button
    type="button"
    [attr.aria-label]="ariaLabel"
    class="btn btn-lg btn-icon-only btn-outline-secondary bg-transparent border-0 dropdown-toggle"
    [ngClass]="{ selected: isOpen$ | async, disabled: disabled }"
    aria-haspopup="true"
    [attr.aria-expanded]="isOpen$ | async"
    (click)="toggleMenu()"
    [disabled]="disabled"
  >
    <ng-content select="[icon]"></ng-content>
  </button>
  <div
    class="dropdown-menu dropdown-menu-end p-0 shadow-sm float-none"
    style="right: 0; left: auto"
    [ngClass]="{ show: isOpen$ | async }"
    container="body"
  >
    <ng-content></ng-content>
  </div>
</div>
